import { useState } from 'react';
import BakeasyTextField, { BakeasyTextFieldProps } from './BakeasyTextField';
import { t } from 'i18next';

function BakeasyTextFieldPassword(props: BakeasyTextFieldProps) {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = (): void => setShowPassword(!showPassword);

  return (
    <BakeasyTextField
      type={showPassword ? 'text' : 'password'}
      name="password"
      label={t('PASSWORD')}
      placeHolder={t('ENTER_YOUR_PASSWORD')}
      value={props?.value}
      required={props?.required}
      showPassword={showPassword}
      onChange={props?.onChange}
      onIconClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        handleClickShowPassword();
      }}
    />
  );
}

export default BakeasyTextFieldPassword;
